<div class="body" [formGroup]="formGroup">

    <ng-container *ngIf="doubletService && (doubletService.checkerVisible$|async)">

        <app-doublet-checker style="margin-bottom: 1rem;"></app-doublet-checker>

    </ng-container>

    <app-select-location2 formControlName="locationparent" class="width" [appearance]="appearance"></app-select-location2>

    <div class="content-wrapper">

        <div class="section header-data-wrapper">

            <app-location-label *ngIf="locationParentControl.value" [location]="locationParentControl.value|locationObject|async" headline="Hauptgebäude" style="margin-bottom: 1rem; display: block;"></app-location-label>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label class="label">Etage</mat-label>
                <input formControlName="locationfloor" matInput placeholder="z.B. 1.OG" [readonly]="!editMode" />
            </mat-form-field>

            <mat-form-field class="width" [appearance]="appearance">
                <mat-label class="label">Gebäudeteil</mat-label>
                <input formControlName="locationpart" matInput placeholder="z.B. Hinterhaus" [readonly]="!editMode" />
            </mat-form-field>

        </div>

        <div class="section quill-wrapper quill-wrapper-white-toolbar quill-wrapper-graduated-bg">

            <quill-editor formControlName="locationinfo" [modules]="modules"></quill-editor>

        </div>

    </div>

</div>